import { t } from "../../../core/translate";
import React from "react";
import styled, { withTheme } from "styled-components";
import MediaQueryOverride from "../../../components/mediaquery/media-query-override";
import {
  styledMedia,
  jsQueries
} from "../../../components/mediaquery/breakpoints";
import { actions as uiLibraryActions } from "../../../../redux/ui/library";
import { connect } from "react-redux";
import { Button } from "@vitalsource/vstui";
import * as bookActions from "../../../../redux/book/actions";
import { selectors as bridgeSelectors } from "../../../../redux/bridge";

const ReadNowButtonContainer = styled.div`
  margin-top: 15px;
  ${styledMedia.small`
  margin-top: 10px;
`}
`;

function OpenFeaturedBookButton({
  openBookPanel,
  openBook,
  theme,
  isActive,
  hasUnlimitedAccess,
  hasAvailableUserCreditsForAsset,
  hasAvailableCopies
}) {
  let buttonText = "";
  let buttonAction;
  if (isActive || hasUnlimitedAccess) {
    buttonText = t("explore.read-now");
    buttonAction = openBook;
  } else if (hasAvailableUserCreditsForAsset && hasAvailableCopies) {
    buttonText = t("library.borrow");
    buttonAction = openBookPanel;
  } else {
    buttonText = t("library.view-details");
    buttonAction = openBookPanel;
  }

  return (
    <ReadNowButtonContainer>
      <MediaQueryOverride query={jsQueries.small} size="small">
        <MediaQueryOverride query={jsQueries.medium} size="medium">
          <Button
            color="white"
            colorBehindButton={theme.color.base.getShade(7)}
            onClick={buttonAction}
            size="large"
          >
            {buttonText}
          </Button>
        </MediaQueryOverride>
      </MediaQueryOverride>
    </ReadNowButtonContainer>
  );
}

const mapStateToProps = (state, props) => ({
  isActive: bridgeSelectors.isActive(state, props.asset.vbid),
  hasUnlimitedAccess: bridgeSelectors.hasUnlimitedAccess(
    state,
    props.asset.vbid
  ),
  hasAvailableUserCreditsForAsset: bridgeSelectors.hasAvailableUserCreditsForAsset(
    state,
    props.asset.vbid
  ),
  hasAvailableCopies: bridgeSelectors.hasAvailableCopies(
    state,
    props.asset.vbid
  )
});

const mapDispatchToProps = (dispatch, props) => ({
  openBookPanel: () =>
    dispatch(
      uiLibraryActions.openSimpleBookPanel(props.asset.vbid, props.asset.title)
    ),
  openBook: () => dispatch(bookActions.launchBridgeBook(props.asset.vbid))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTheme(OpenFeaturedBookButton));
